import { useState } from "react";
import TokenHelper from "../helpers/TokenHelper";

export function useToken() {

  const [accessToken] = useState(() => {
    return TokenHelper.getLocalAccessToken();
  });

  const [refreshToken] = useState(() => {
    return TokenHelper.getLocalRefreshToken();
  });

  return {
    accessToken,
    refreshToken
  };
}
